import { editMediaSettings } from "./editMediaSettings";
import { editSignupBackgroundColor } from "./editSignupBackgroundColor";
import { uploadPhoto } from "./uploadPhoto";

const mockResponses = {
  editSignupBackgroundColor,
  uploadPhoto,
  editMediaSettings,
};

export default mockResponses;